import React from "react";

const stockAdjustmentBatchRoutes = [
  {
    path: "/stock-adjustment-Batch/addNew",
    component: React.lazy(() => import("./StockAdjustmentBatchForm")),
    permission: "Permissions.StockAdjustmentBatches.Add",
  },
  {
    path: "/stock-adjustment-Batch/stock-adjustment-batch-list",
    component: React.lazy(() => import("./StockAdjustmentBatchList")),
    permission: "Permissions.StockAdjustmentBatches.View",
  },
];

export default stockAdjustmentBatchRoutes;
